import Dexie from "dexie";
import VuexStore from "@/store";

export class DataStore {
  constructor(name) {
    this.name = name;
    this.idbName = name;
  }
  async createDataStore(userUUID) {
    this.idb = null;
    this.list = new Map();
    this.topic = new Map();
    this.data = new Map();
    this.state = new Map([["unread", new Map()]]);
    this.VuexStore = VuexStore;
    await createIndexedDBHelper(userUUID, this);

  }
}

const idbSchemaVersion = new Date().getTime();
const idbSchema = {
  message_list: "id, date, timestamp, channel, unify_id",
  message_topic: "id, topicId, sendFrom, date, timestamp, channel, unify_id, subjectId",
  message_state: "id, timestamp, channel, unify_id",
  message: "id, topicId, sendFrom, date, timestamp, channel, unify_id",
  notification_list: "id, topicId, sendFrom, date, timestamp",
  notification: "id, topicId, sendFrom, date, timestamp",
}

const idb = { dexie: null };

function openIDB(dbName = "temp") {
  if (!idb.dexie) {
    idb.dexie = new Dexie(`xstudi-teacher-${dbName}`);
    idb.dexie.version(idbSchemaVersion).stores(idbSchema);
  }
}

export async function createIndexedDBHelper(userUUID, pool) {
  await openIDB(userUUID);

  if (!pool.idb) {
    pool.idb = {};

    idb[pool.idbName] = idb.dexie[pool.idbName];
    pool.idb.data = idb[pool.idbName];

    idb[pool.idbName + "_list"] = idb.dexie[pool.idbName + "_list"];
    pool.idb.list = idb[pool.idbName + "_list"];

    if (pool.idbName === "message") {
      idb[pool.idbName + "_topic"] = idb.dexie[pool.idbName + "_topic"];
      pool.idb.topic = idb[pool.idbName + "_topic"];
      idb[pool.idbName + "_state"] = idb.dexie[pool.idbName + "_state"];
      pool.idb.state = idb[pool.idbName + "_state"];
    }
    return true;
  }
  return false;
}
